import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  OnInit,
  Output,
} from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { TranslocoModule } from '@jsverse/transloco';
import { FormBaseComponent } from '@anihis/shared/src/shared/base-components/form-base.component';

@Component({
  selector: 'anihis-lab-hemato-dog',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatCardModule,
    MatFormFieldModule,
    MatInputModule,
    TranslocoModule,
  ],
  templateUrl: './lab-hemato-dog.component.html',
  styleUrls: ['./lab-hemato-dog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LabHematoDogComponent extends FormBaseComponent implements OnInit {
  @Output() formChange = new EventEmitter<any>();
  leftParams: Array<{ labelKey: string; control: string }> = [];
  unitMap: Record<string, string> = {};
  refMap: Record<string, string> = {};

  constructor() {
    super();
    this.form = this.fb.group({
      wbc: new FormControl(''),
      lymphCount: new FormControl(''),
      monCount: new FormControl(''),
      granCount: new FormControl(''),
      lymphPercent: new FormControl(''),
      monPercent: new FormControl(''),
      granPercent: new FormControl(''),
      rbc: new FormControl(''),
      hgb: new FormControl(''),
      hct: new FormControl(''),
      mcv: new FormControl(''),
      mch: new FormControl(''),
      mchc: new FormControl(''),
      rdw: new FormControl(''),
      plt: new FormControl(''),
      mpv: new FormControl(''),
      pdw: new FormControl(''),
      pct: new FormControl(''),
      eos: new FormControl(''),
      bloodSmear: new FormControl(''),
      veterinarianName: new FormControl(''),
    });

    this.leftParams = [
      { labelKey: 'WBC', control: 'wbc' },
      { labelKey: 'Lymph#', control: 'lymphCount' },
      { labelKey: 'Mon#', control: 'monCount' },
      { labelKey: 'Gran#', control: 'granCount' },
      { labelKey: 'Lymph%', control: 'lymphPercent' },
      { labelKey: 'Mon%', control: 'monPercent' },
      { labelKey: 'Gran%', control: 'granPercent' },
      { labelKey: 'RBC', control: 'rbc' },
      { labelKey: 'HGB', control: 'hgb' },
      { labelKey: 'HCT', control: 'hct' },
      { labelKey: 'MCV', control: 'mcv' },
      { labelKey: 'MCH', control: 'mch' },
      { labelKey: 'MCHC', control: 'mchc' },
      { labelKey: 'RDW', control: 'rdw' },
      { labelKey: 'PLT', control: 'plt' },
      { labelKey: 'MPV', control: 'mpv' },
      { labelKey: 'PDW', control: 'pdw' },
      { labelKey: 'PCT', control: 'pct' },
      { labelKey: 'EOS', control: 'eos' },
    ];

    this.unitMap = {
      wbc: 'x10^9/L',
      lymphCount: 'x10^9/L',
      monCount: 'x10^9/L',
      granCount: 'x10^9/L',
      lymphPercent: '%',
      monPercent: '%',
      granPercent: '%',
      rbc: 'x10^9/L',
      hgb: 'g/L',
      hct: '%',
      mcv: 'fL',
      mch: 'pg',
      mchc: 'g/L',
      rdw: '%',
      plt: 'x10^9/L',
      mpv: 'fL',
      pdw: '',
      pct: '%',
      eos: '%',
    };

    this.refMap = {
      wbc: '6.0 - 17.0',
      lymphCount: '0.8 - 5.1',
      monCount: '0.0 - 1.8',
      granCount: '4.0 - 12.6',
      lymphPercent: '12.0 - 30.0',
      monPercent: '2.0 - 9.0',
      granPercent: '60.0 - 83.0',
      rbc: '5.5 - 8.5',
      hgb: '110 - 190',
      hct: '39.0 - 56.0',
      mcv: '62.0 - 72.0',
      mch: '20.0 - 25.0',
      mchc: '300 - 380',
      rdw: '11.0 - 15.5',
      plt: '117 - 460',
      mpv: '7.0 - 12.9',
      pdw: '',
      pct: '',
      eos: '',
    };
  }

  override ngOnInit(): void {
    super.ngOnInit();
    this.subs.sink = this.form.valueChanges.subscribe((v) =>
      this.formChange.emit(v),
    );
  }
}
